<template>
	<div class="pt-5">
		<v-skeleton-loader v-if="profileSectionLoading" v-bind="attrs" type="card" />
		<div v-else-if="profileSection && profileSection.visibilityInteraction">
			<div v-for="(setting, i) in profileSection.visibilityInteraction" :key="i">
				<div v-if="setting.block_name === 'visibilityInteraction'">
					<div
						style="background-color: #f3f3f6"
						v-for="(item, index) in setting.block_data"
						:key="index"
					>
						<div v-if="item.field === 'show_user_list'" class="visibility-page">
							{{ item.title }}
							<div
								@click="toggleStatus(item)"
								:style="{
									backgroundColor: !item.value
										? '#9b9b9b'
										: 'var(--secondary_color)',
								}"
								class="session-question-form__anonymous-wrapper__button"
							>
								<div
									:style="{
										transform: item.value
											? 'translateX(20px)'
											: 'translateX(0)',
									}"
									class="session-question-form__anonymous-wrapper__button__circle"
								></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'VisibilityProfile',
	data() {
		return {
			attrs: {
				elevation: 0,
			},
		}
	},
	mixins: [Dwh],
	methods: {
		...mapActions('app', ['setPageTitle']),
		...mapActions('auth', ['getProfileSection', 'visibilityChange', 'clearProfileSection']),
		dwhActionSaveNote() {
			this.sendTrigger({
				module: 'My Account',
				category: 'Visibility & Interactions',
				action: 'view_visibility_settings',
				title: 'Visibility & Interactions',
				id1: this.currentUser.user_id,
			})
		},
		dwhActionToggleProfileVisibility(value) {
			let type = value ? 'on' : 'off'
			this.sendTrigger({
				module: 'My Account',
				category: 'Visibility & Interactions',
				action: 'action_toggle_profile_visibility',
				title: 'Profile Visibility',
				id1: this.currentUser.user_id,
				data: type,
			})
		},
		async toggleStatus(item) {
			const newValue = item.value ? 0 : 1
			item.value = newValue

			try {
				await this.visibilityChange({ [item.field]: newValue })
				this.dwhActionToggleProfileVisibility(newValue)
			} catch (e) {
				console.error(e)
				item.value = newValue ? 0 : 1
			}
		},
	},
	computed: {
		...mapGetters('auth', [
			'profileSection',
			'profileSectionLoading',
			'profileSectionError',
			'profile',
		]),
		currentUser() {
			return this.profile
		},
	},
	mounted() {
		this.dwhActionSaveNote()
		this.setPageTitle('Visibility & Interaction')
	},
	created() {
		this.getProfileSection('visibilityInteraction')
	},
	beforeDestroy() {
		this.setPageTitle('')
		this.clearProfileSection()
	},
}
</script>

<style lang="scss">
.visibility-page {
	display: flex;
	width: 100%;
	padding: 12px;
	justify-content: space-between;
	align-items: center;
	background-color: #ffffff;
	border: 1px solid #e2e2e2;
	border-radius: 8px;
	margin-bottom: 8px;
	color: #4a4a4a;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 100%;
	letter-spacing: 0;
}
</style>
